import { MODE_3D_VIEW } from '@constants'
import { useModularUiStore } from '@utils/modularSnap/modularUiStore'
import { useAppStore } from '@store'
import { useEffect } from 'react'

/**
 * Red de seguridad: restaura el modo si queda colgado tras un arrastre.
 * No toca itemDragActive (lo gestiona useMeshFloorDrag3D) para no reactivar la cámara a mitad de gesto.
 */
export function ModularFloorDragSafety() {
  useEffect(() => {
    const releaseStuckMode = () => {
      window.setTimeout(() => {
        const store = useAppStore.getState()
        const dragActive = useModularUiStore.getState().itemDragActive
        if (!dragActive && store.mode === 'MODE_DRAGGING_ITEM_3D') {
          store.setMode(MODE_3D_VIEW)
        }
      }, 0)
    }

    window.addEventListener('pointerup', releaseStuckMode)
    window.addEventListener('pointercancel', releaseStuckMode)
    window.addEventListener('blur', releaseStuckMode)

    return () => {
      window.removeEventListener('pointerup', releaseStuckMode)
      window.removeEventListener('pointercancel', releaseStuckMode)
      window.removeEventListener('blur', releaseStuckMode)
    }
  }, [])

  return null
}
